export default __webpack_public_path__ + "static/halfWidth1-58a7a2deeb8b8ddb1ea5a1660bc6115c.png";